import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useFormat } from "@/lib/format";

const TOP = 5;

export const TopExpenses = () => {
  const { money } = useFormat();
  const { data } = useQuery({ queryKey: ["planning", "personal", "me", "operations"], queryFn: () => api.get("/planning/personal/me/operations").then((r) => r.data) });
  const top = (data?.items || []).filter((o) => o.amount > 0).sort((a, b) => b.amount - a.amount).slice(0, TOP);
  if (!top.length) return null;
  const max = top[0].amount;
  return (
    <div className="mt-4 border-t border-border pt-3" data-testid="top-expenses">
      <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Plus grosses dépenses du mois</div>
      <ol className="space-y-2">
        {top.map((o, i) => (
          <li key={o.id} className="text-sm" data-testid={`top-expense-${i}`}>
            <div className="flex items-baseline gap-2">
              <span className="num w-4 shrink-0 text-xs text-muted-foreground">{i + 1}</span>
              <span className="min-w-0 flex-1 truncate">{o.label}<span className="ml-1.5 text-[11px] text-muted-foreground">{o.category_label}</span></span>
              <span className="num shrink-0 font-semibold" data-testid={`top-expense-amount-${i}`}>{money(o.amount, { maximumFractionDigits: 2 })}</span>
            </div>
            <div className="ml-6 mt-1 h-1.5 overflow-hidden rounded-full bg-secondary"><div className="h-full rounded-full bg-[#87B8A5]" style={{ width: `${(o.amount / max) * 100}%` }} /></div>
          </li>
        ))}
      </ol>
    </div>
  );
};
